import { Button, Modal, Avatar, Popconfirm, Input, Divider, Popover } from 'antd'
import * as React from 'react'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import './preview.less'
import { ObsKeyToURL } from '../../api/utils'
import { Lesson, LessonAnnex, newCourse, newCourseAnnex } from '../../api/course'
import { CornerMarker } from '../CornerMarker'
import API from '../../api'
import InputFile from '../InputFile'
import { FileInfo, newFileInfo } from '../../api/file_info'
import PreviewDocument from './previewPpt'
import PreivewVideo from './videoPreview'
import { DownloadFileModal } from 'components/DownloadFile'
import { useSelector } from 'react-redux'
import { IState } from 'reducers'

const Preview = () => {
  const history = useHistory()

  // 是否显示上传
  const [updateVisible, setUpdateVisible] = useState(false)
  const [previewFile, setPreviewFile] = useState<LessonAnnex>(newCourseAnnex())
  const [downloading, setDownloading] = useState(false)
  const [course, setCourse] = useState<Lesson>(newCourse())
  const [annexes, setAnnexes] = useState<LessonAnnex[]>([])
  const [disabled, setDisabled] = useState(false)
  const [uploadFile, setUploadFile] = useState<FileInfo>(newFileInfo())
  const [total, setTotal] = useState(0)
  const [grade_id, setGrade] = useState(0)
  const user = useSelector((state: IState) => state.user)
  // 获取用户信息 设置课程及 预览内容
  useEffect(() => {
    // 初始化file信息
    setUploadFile({
      ...uploadFile,
      name: previewFile.name,
      suffix: previewFile.suffix,
      url: previewFile.url,
    })
    if (user.type === 'guest') {
      setDisabled(true)
    }

    setPreviewFile((history.location.state as any).annex)
    let course: Lesson = (history.location.state as any).course
    setCourse(course)
    setAnnexes([...course.coursewares!, ...course.lesson_plans!, ...course.videos!])
    setTotal((history.location.state as any).total)
    setGrade((history.location.state as any).grade_id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 打开更新文件窗口
  const showUpdateModal = () => {
    setUpdateVisible(true)
  }
  const doUpdate = () => {
    // 判断文件是否变更
    if (previewFile.url !== uploadFile.url || previewFile.name !== uploadFile.name) {
      let annex = newCourseAnnex()
      annex.lesson_annex_id = typeof (previewFile as LessonAnnex).lesson_annex_id
      annex.url = uploadFile.url
      annex.suffix = uploadFile.suffix

      // 更新
      if (
        previewFile.url !== uploadFile.url &&
        ['ppt', 'pptx', 'doc', 'docx'].includes(previewFile.suffix)
      ) {
        annex.should_update_preview = true
      }

      if (previewFile.name !== uploadFile.name) {
        annex.name = uploadFile.name
      }

      API.updateCourseAnnex(annex).then(() => {
        history.goBack()
      })
    }
    cancelUpdate()
  }
  const cancelUpdate = () => {
    setUpdateVisible(false)
  }

  const changeFileName = e => {
    setUploadFile({ ...uploadFile, name: e.target.value })
  }

  // 判断文件类型是否变更，不允许变更
  const suffixChanged = () => {
    return (
      API.getCourseAnnexType(uploadFile.suffix).value !==
      API.getCourseAnnexType(previewFile.suffix).value
    )
  }

  // 删除课程附件
  const deleteAnnex = () => {
    API.delCourseAnnex(previewFile.lesson_annex_id).then(() => {
      history.goBack()
    })
  }

  useEffect(() => {
    if (previewFile.lesson_annex_id !== '') {
      switch (previewFile.suffix) {
        case 'pdf':
        case 'doc':
        case 'docx':
        case 'ppt':
        case 'pptx':
          return setPIV(<PreviewDocument previewFile={previewFile} />)
        default:
          return setPIV(<PreivewVideo previewFile={previewFile} />)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewFile.lesson_annex_id])
  const [pDIV, setPIV] = useState(<div></div>)

  return (
    <>
      <div className="pdf-container">
        <div id="preview_container">{pDIV}</div>
        <div className="pdf-card-group">
          <div className="pdf-card-info">
            <div
              className="pdf-card-title-group"
              style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/pdf-card-bg.png)` }}
            >
              <div className="pdf-card-title">
                <div className="title bold" style={{ color: '#F5F5F5' }}>
                  第 {course.renderSort} 节 {course.name}
                </div>
              </div>
            </div>
            <div className="pdf-card-file-group">
              <div className="title bold" style={{ color: '#262626' }}>
                {previewFile.name}{' '}
                <div style={{ display: 'inline-block', marginLeft: 8 }}>
                  <CornerMarker suffix={previewFile.suffix} />
                </div>
              </div>
              <div className="pdf-card-author-group">
                <div className="pdf-card-author-outer">
                  <div>
                    <Avatar src={ObsKeyToURL(previewFile.author.image)} />
                  </div>
                  <div>
                    <span className="small" style={{ color: '#8C8C8C' }}>
                      {previewFile.author.nickname || previewFile.author.name}
                    </span>
                  </div>
                </div>
                <div className="pdf-card-icon-outer">
                  {API.getShortDateStr(previewFile.updated_at)}
                </div>
              </div>
            </div>
          </div>
          <Divider className="pdf-card-divider" />
          <div className="pdf-card-type-group">
            <div className="second-title">全部类型</div>
            {/* 滚动条 */}
            <div className="pdf-card-type-outer">
              {annexes.map(item => (
                <div
                  className={
                    item.lesson_annex_id === previewFile.lesson_annex_id
                      ? 'pdf-card-type-active pdf-card-type'
                      : 'pdf-card-type'
                  }
                  key={item.lesson_annex_id}
                  onClick={() => {
                    setPreviewFile(item)
                  }}
                >
                  <div style={{ marginRight: 18, fontSize: 18, width: 42 }}>
                    {API.getCourseAnnexType(item.suffix).name}
                  </div>
                  <div>{item.name}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="pdf-card-button-group">
            {/* <Button style={{color:'rgba(0, 0, 0, 0.85)'}}>重新上传</Button> */}
            {user.user_id === previewFile.author.user_id ? (
              <div>
                {previewFile.lesson_annex_id === '' ? (
                  <div></div>
                ) : (
                  <Button
                    onClick={showUpdateModal}
                    style={{ marginRight: 24 }}
                    className="pdf-card-button"
                  >
                    更新
                  </Button>
                )}
                <Popconfirm
                  title="确认删除？"
                  okText="确认"
                  cancelText="取消"
                  onConfirm={deleteAnnex}
                >
                  <Button danger className="pdf-card-button">
                    删除
                  </Button>
                </Popconfirm>
              </div>
            ) : (
              ''
            )}
            {user.type === 'guest' ? (
              <Popover content={<div style={{ padding: 12 }}>当前用户没有权限下载</div>}>
                <Button type="primary" disabled={true} className="pdf-card-button">
                  下载
                </Button>
              </Popover>
            ) : (
              <Button
                type="primary"
                onClick={() => setDownloading(true)}
                disabled={disabled}
                className="pdf-card-button"
              >
                下载
              </Button>
            )}
          </div>
        </div>
      </div>
      {downloading ? (
        <div className="download-progress">
          <DownloadFileModal
            name={previewFile.name}
            suffix={previewFile.suffix}
            url={previewFile.url}
            downloading={downloading}
            setDownloading={setDownloading}
          />
        </div>
      ) : (
        <></>
      )}
      <Modal
        title="更新文件"
        visible={updateVisible}
        onCancel={cancelUpdate}
        width="814px"
        footer={[
          <Button key="cancel" onClick={cancelUpdate}>
            取消
          </Button>,
          <Button key="update" onClick={doUpdate} type="primary" disabled={suffixChanged()}>
            确认
          </Button>,
        ]}
      >
        <div className="upload-file-group">
          <InputFile initFile={uploadFile} keyPrefix="course/annex/" setFile={setUploadFile} />
          <div
            style={{
              width: 360,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            文件名:
            <Input value={uploadFile.name} onChange={changeFileName} style={{ width: 300 }} />
          </div>
          <div style={{ width: 120 }}>上传到: {API.getCourseAnnexType(previewFile.suffix).name}</div>
        </div>
      </Modal>
    </>
  )
}

export default Preview
